var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (i18n) {pug_mixins["koValidationError"] = pug_interp = function(item, id){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cul" + (pug.attr("data-bind", 'visible: !' + item + '.isValid(), foreach: ' + item + '.errors, attr: {"aria-hidden": ' + item + '.isValid()}', true, true)+pug.attr("id", id ? id : item + 'ValidationError', true, true)+" role=\"alert\"") + "\u003E\u003Cli role=\"presentation\"\u003E\u003Cdiv class=\"error\" data-bind=\"html: $data\" role=\"alert\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E";
};
pug_mixins["popupHelp"] = pug_interp = function(popupId, ariaLabelContext, i18n){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var templateString = (i18n && i18n.get && i18n.get('Click to learn more about {{item}}')) || (i18n && i18n.getString && i18n.getString('Click to learn more about {{item}}')) || null
pug_html = pug_html + "\u003Ca" + (" class=\"helpbutton\""+" type=\"helppopup\" role=\"button\""+pug.attr("topic", popupId, true, true)+pug.attr("data-help", true, true, true)+" onclick=\"PopupController.PopupJsClick(this)\" href=\"javascript:void(0);\""+pug.attr("aria-label", templateString ? templateString.replace('{{item}}', ariaLabelContext) : ariaLabelContext, true, true)) + "\u003E\u003C\u002Fa\u003E";
};
pug_mixins["koCharactersRemaining"] = pug_interp = function(item, id){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"remaining-hint help-block\"\u003E\u003Cspan" + (pug.attr("data-bind", 'text:' + item + '.char_rem', true, true)+pug.attr("id", id ? id : item + '_CharactersRemaining', true, true)+" role=\"status\" aria-live=\"polite\"") + "\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
};




pug_mixins["dynamicTextMenu"] = pug_interp = function(property){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"btn-group\"\u003E\u003Ca" + (pug.attr("class", pug.classes(["dropdown-toggle","legacy-dropdown-toggle",property + '-dynamicTextLink'], [false,false,true]), false, true)+" data-toggle=\"dropdown\" aria-haspopup=\"true\" href=\"javascript:void(0);\"") + "\u003E" + (pug.escape(null == (pug_interp = i18n.get('Ad_DynamicText')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cul" + (pug.attr("class", pug.classes(["dropdown-menu","dropdown-menu-right",property + '-dynamicTextMenu'], [false,false,true]), false, true)+pug.attr("data-bind", 'foreach:' + property + '.dynamicTextMenu', true, true)+" role=\"menu\"") + "\u003E\u003Cli\u003E\u003Ca" + (" class=\"dynamicText\""+pug.attr("data-bind", 'text: text, click: $parent.' + property + '.appendDynamicText', true, true)+" role=\"menuitem\" href=\"javascript:void(0);\"") + "\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
};






























pug_mixins["koValidationError"] = pug_interp = function(item, id){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cul" + (pug.attr("data-bind", 'visible: !' + item + '.isValid(), foreach: ' + item + '.errors, attr: {"aria-hidden": ' + item + '.isValid()}', true, true)+pug.attr("id", id ? id : item + 'ValidationError', true, true)+" role=\"alert\"") + "\u003E\u003Cli role=\"presentation\"\u003E\u003Cdiv class=\"error\" data-bind=\"html: $data\" role=\"alert\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E";
};
pug_mixins["popupHelp"] = pug_interp = function(popupId, ariaLabelContext, i18n){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var templateString = (i18n && i18n.get && i18n.get('Click to learn more about {{item}}')) || (i18n && i18n.getString && i18n.getString('Click to learn more about {{item}}')) || null
pug_html = pug_html + "\u003Ca" + (" class=\"helpbutton\""+" type=\"helppopup\" role=\"button\""+pug.attr("topic", popupId, true, true)+pug.attr("data-help", true, true, true)+" onclick=\"PopupController.PopupJsClick(this)\" href=\"javascript:void(0);\""+pug.attr("aria-label", templateString ? templateString.replace('{{item}}', ariaLabelContext) : ariaLabelContext, true, true)) + "\u003E\u003C\u002Fa\u003E";
};
pug_mixins["dynamicTextMenu"] = pug_interp = function(property){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"btn-group\"\u003E\u003Ca" + (pug.attr("class", pug.classes(["dropdown-toggle","legacy-dropdown-toggle",property + '-dynamicTextLink'], [false,false,true]), false, true)+" data-toggle=\"dropdown\" aria-haspopup=\"true\" href=\"javascript:void(0);\"") + "\u003E" + (pug.escape(null == (pug_interp = i18n.get('Ad_DynamicText')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cul" + (pug.attr("class", pug.classes(["dropdown-menu","dropdown-menu-right",property + '-dynamicTextMenu'], [false,false,true]), false, true)+pug.attr("data-bind", 'foreach:' + property + '.dynamicTextMenu', true, true)+" role=\"menu\"") + "\u003E\u003Cli\u003E\u003Ca" + (" class=\"dynamicText\""+pug.attr("data-bind", 'text: text, click: $parent.' + property + '.appendDynamicText', true, true)+" role=\"menuitem\" href=\"javascript:void(0);\"") + "\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
};
































pug_html = pug_html + "\u003Cdiv class=\"row ac-container\"\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cdiv class=\"headlines-container\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"descriptions-container\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined));;return pug_html;};
module.exports = template;